import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Trustedcorporatecabserviceinchennai() {



  const cardData =
  {
    keyword: 'Trusted Corporate Cab Services in Chennai',
    heading: 'Aaryan Travels: Trusted Corporate Cab Services in Chennai',
    headingDescription: ' Aaryan Travels provides Trusted Corporate Cab Services in Chennai for IT companies, manufacturing units, business executives, and corporate travelers who demand punctual and professional mobility solutions. Whether you require employee transportation, client pickups, airport transfers from Chennai International Airport, or intercity travel to Bengaluru, Coimbatore, or Pondicherry, our fleet of sedans, SUVs, and luxury vehicles ensures a smooth and comfortable journey. With trained chauffeurs, GPS-enabled vehicles, monthly billing options, and 24/7 operational support, we deliver reliable transportation across key corporate hubs like OMR, Guindy, Ambattur, and Siruseri. Aaryan Travels is your trusted partner for corporate cab services that prioritize safety, punctuality, and professionalism.',

    top: 'Top Places to Visit in Chennai with Aaryan Travels',

 "topPlaces": [
  {
    "title": "Marina Beach",
    "description": "Stretching over 13 kilometers along the Bay of Bengal, Marina Beach is India’s longest natural urban beach. Visitors enjoy sunrise walks, horse rides, and traditional snacks like sundal and murukku. Memorials and statues along the promenade add cultural character. The sea breeze and golden sands attract locals and tourists alike. Marina Beach is Chennai’s vibrant coastal treasure."
  },
  {
    "title": "Kapaleeshwarar Temple",
    "description": "Kapaleeshwarar Temple in Mylapore is a stunning Dravidian-style shrine dedicated to Lord Shiva. Its colorful gopuram towers and intricate carvings reflect ancient craftsmanship. Devotees gather during festivals like Panguni Peruvizha for grand celebrations. Surrounded by flower stalls and traditional shops, it exudes timeless charm. Kapaleeshwarar Temple is Chennai’s spiritual and cultural jewel."
  },
  {
    "title": "Fort St. George",
    "description": "Fort St. George, built in 1644 by the British East India Company, is the first English fortress in India. It now serves as the Tamil Nadu Legislative Assembly and houses a museum displaying colonial artifacts and weaponry. St. Mary’s Church inside is one of the oldest Anglican churches in Asia. Fort St. George is Chennai’s historic landmark of colonial legacy."
  },
  {
    "title": "Santhome Basilica",
    "description": "Santhome Basilica is a neo-Gothic church built over the tomb of Saint Thomas the Apostle. Its white towers and stained-glass windows create a serene atmosphere. The underground chapel and relics attract pilgrims from around the world. Located near the seashore, it adds beauty to the waterfront skyline. Santhome Basilica is Chennai’s sacred link to Christian heritage."
  },
  {
    "title": "Elliot’s Beach (Besant Nagar Beach)",
    "description": "Elliot’s Beach is a quieter alternative to Marina Beach, popular among youngsters and families. Visitors enjoy evening walks, seaside cafes, and relaxed ambiance. The Karl Schmidt Memorial and nearby Ashtalakshmi Temple add charm to the coastline. Clean sands and gentle waves make it ideal for leisure. Elliot’s Beach is Chennai’s peaceful seaside retreat."
  },
  {
    "title": "Valluvar Kottam",
    "description": "Valluvar Kottam is a grand monument dedicated to the celebrated Tamil poet-saint Thiruvalluvar. Built in the shape of a temple chariot, it features inscriptions of all 1,330 couplets from the Thirukkural. The surrounding auditorium hosts various cultural events. It stands as a proud tribute to Tamil literature. Valluvar Kottam is Chennai’s architectural ode to wisdom."
  },
  {
    "title": "Government Museum, Egmore",
    "description": "The Government Museum in Egmore is India’s second-oldest museum, housing rare artifacts, bronze idols, fossils, and ancient coins. The National Art Gallery inside showcases exquisite paintings and sculptures. The Indo-Saracenic architecture adds grandeur to the experience. It is both educational and awe-inspiring. The museum is Chennai’s cultural encyclopedia."
  },
  {
    "title": "Guindy National Park",
    "description": "Guindy National Park is one of India’s smallest yet richest urban wildlife parks. It is home to blackbucks, spotted deer, jackals, and over 100 bird species. Nearby Children’s Park and Snake Park add to family entertainment. Shaded paths make it perfect for nature walks. Guindy Park is Chennai’s green sanctuary amidst urban bustle."
  },
  {
    "title": "Express Avenue Mall",
    "description": "Express Avenue Mall is a premier shopping and entertainment hub featuring luxury brands, multiplex cinemas, and a large food court. South India’s biggest gaming arcade attracts youngsters. The modern architecture and vibrant ambiance make it a favorite hangout spot. Express Avenue is Chennai’s hotspot for leisure and lifestyle."
  },
  {
    "title": "Arignar Anna Zoological Park (Vandalur Zoo)",
    "description": "Vandalur Zoo is India’s largest zoological park, spread across 1,500 acres. It houses lions, tigers, elephants, reptiles, and rare species. Safari rides and butterfly parks add to the excitement. The lush greenery offers a refreshing day-out experience for families. Vandalur Zoo is Chennai’s adventurous world of wildlife."
  }
],


 "services": [
  {
    "name": "Trusted Corporate Cab Services in Chennai",
    "description": "Our Trusted Corporate Cab Services in Chennai are tailored to meet the rigorous demands of businesses, ensuring reliable, safe, and efficient transportation solutions. Whether for daily employee commutes, executive travel, or client pickups, we provide a well-maintained fleet and professional chauffeurs who understand corporate etiquette. With flexible booking options, real-time tracking, and dedicated customer support, we help organizations optimize their travel management while maintaining cost-effectiveness and high service standards."
  },
  {
    "name": "Reliable Business Taxi Chennai",
    "description": "Reliable Business Taxi Chennai offers dependable and punctual taxi services for all your business needs. Our fleet consists of clean, comfortable vehicles driven by experienced professionals committed to timely pickups and drop-offs. Whether it's airport transfers, client meetings, or city travel, we ensure smooth and stress-free rides tailored for business travelers."
  },
  {
    "name": "Corporate Transport Chennai",
    "description": "Corporate Transport Chennai specializes in providing scalable transportation solutions for companies of all sizes. From individual executive travel to large-scale staff movements, we offer route planning, shift scheduling, and GPS-enabled vehicles to guarantee efficient and transparent operations, enabling businesses to focus on their core activities while we handle their transportation needs."
  },
  {
    "name": "Office Cab Services Chennai",
    "description": "Office Cab Services Chennai ensures seamless daily commutes for your employees with well-coordinated scheduling, safe vehicles, and professional drivers. Designed to reduce tardiness and increase productivity, our office cab solutions cater to different shift timings and locations, backed by reliable support and easy billing processes."
  },
  {
    "name": "Corporate Chauffeur Chennai",
    "description": "Experience premium service with our Corporate Chauffeur Chennai offering, where trained drivers provide discreet, safe, and courteous rides for your executives and VIP clients. Our chauffeurs adhere to high standards of professionalism, ensuring a comfortable and productive travel experience in luxury sedans and SUVs."
  },
  {
    "name": "Employee Cab Chennai",
    "description": "Employee Cab Chennai focuses on safe and punctual transportation for your workforce. Our service includes route optimization, real-time vehicle tracking, and verified drivers to provide peace of mind and enhance employee satisfaction. Suitable for all business sectors, we ensure your staff arrive on time and in comfort every day."
  },
  {
    "name": "Chennai Corporate Car Hire",
    "description": "Chennai Corporate Car Hire offers flexible rental options with a premium fleet of sedans, SUVs, and luxury vehicles. Whether for short-term projects, long-term contracts, or special events, our corporate car hire service ensures you have the right vehicle available with professional drivers at competitive rates."
  },
  {
    "name": "Monthly Corporate Cab Chennai",
    "description": "Monthly Corporate Cab Chennai provides cost-effective and convenient monthly packages designed to meet recurring business travel needs. With fixed pricing, priority booking, and dedicated support, our monthly plans simplify transportation management and guarantee consistent service quality for employee and executive mobility."
  },
  {
    "name": "Affordable Corporate Cab Chennai",
    "description": "Affordable Corporate Cab Chennai delivers budget-friendly corporate transportation without compromising quality or reliability. Perfect for startups and SMEs, our service includes modern, clean vehicles and professional chauffeurs to ensure safe, timely, and efficient travel within Chennai and nearby areas."
  },
  {
    "name": "Executive Cab Chennai",
    "description": "Executive Cab Chennai offers luxurious travel options for senior management and VIPs. Our fleet of premium vehicles equipped with modern amenities provides a quiet and comfortable environment ideal for work or relaxation, accompanied by skilled chauffeurs who prioritize professionalism and discretion."
  },
  {
    "name": "Trusted Corporate Taxi Chennai",
    "description": "Trusted Corporate Taxi Chennai is your dependable partner for business transportation needs, combining professionalism with punctuality. Our services are designed to meet high standards of safety, vehicle upkeep, and driver conduct, ensuring consistent quality for corporate clients across various industries."
  },
  {
    "name": "Staff Transport Chennai",
    "description": "Staff Transport Chennai facilitates efficient group transportation solutions for companies with large workforces. Our service includes mini-buses, vans, and multi-utility vehicles with scheduled routes, ensuring timely arrivals and departures that help maintain operational efficiency and employee satisfaction."
  },
  {
    "name": "Premium Corporate Cab Chennai",
    "description": "Premium Corporate Cab Chennai caters to businesses requiring top-notch transportation services for their executives and important guests. Our luxury fleet, coupled with courteous chauffeurs, delivers an unmatched travel experience marked by comfort, reliability, and professionalism."
  },
  {
    "name": "Corporate Car Rental Chennai",
    "description": "Corporate Car Rental Chennai offers a wide range of vehicles for short and long-term corporate needs. Whether for client meetings, airport transfers, or city travel, our flexible rental plans come with professional drivers and round-the-clock support to ensure smooth operations."
  },
  {
    "name": "Trusted Business Cab Chennai",
    "description": "Trusted Business Cab Chennai is a hallmark of reliability and quality in the corporate transport sector. Serving numerous businesses across Chennai, we combine modern vehicles with experienced drivers and seamless booking to provide a trustworthy solution for all your corporate travel demands."
  }
],
"tableData": [
  ["Trusted Corporate Cab Services in Chennai", "Reliable Business Taxi Chennai"],
  ["Corporate Transport Chennai", "Office Cab Services Chennai"],
  ["Corporate Chauffeur Chennai", "Employee Cab Chennai"],
  ["Chennai Corporate Car Hire", "Monthly Corporate Cab Chennai"],
  ["Affordable Corporate Cab Chennai", "Executive Cab Chennai"],
  ["Trusted Corporate Taxi Chennai", "Staff Transport Chennai"],
  ["Premium Corporate Cab Chennai", "Corporate Car Rental Chennai"],
  ["Trusted Business Cab Chennai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Corporate Cab Services in Chennai",
    "WhyChoosedescription": "Aaryan Travels provides reliable and professional corporate cab services tailored for businesses in Chennai."
  },
  {
    "WhyChooseheading": "Punctual Pickup and Drop for Seamless Commutes",
    "WhyChoosedescription": "Ensure timely and hassle-free transportation for your employees and clients across Chennai."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Business Travel",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained for your comfort and professionalism."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Chennai’s Corporate Routes",
    "WhyChoosedescription": "Our drivers know the city well, ensuring efficient and smooth navigation through key business areas."
  },
  {
    "WhyChooseheading": "Transparent Billing and No Hidden Charges",
    "WhyChoosedescription": "Enjoy GST-compliant invoices and upfront pricing to simplify your corporate expense management."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Support for Corporate Clients",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, modifications, and queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans to Suit Your Business Needs",
    "WhyChoosedescription": "Choose from daily, weekly, or monthly cab hire contracts customized to your organization’s requirements."
  },
  {
    "WhyChooseheading": "Wide Fleet of Vehicles for Corporate Travel",
    "WhyChoosedescription": "Select from sedans, SUVs, and tempo travellers based on your team size and travel preferences."
  }
]





























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer trusted corporate cab services in Chennai?',
    answer: 'Yes, Aaryan Travels provides reliable and professional corporate cab services across Chennai for all business travel needs.',
  },
  {
    question: 'How can I book corporate cab services in Chennai with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our dedicated corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Chennai?',
    answer: 'Aaryan Travels offers a fleet of sedans, SUVs, and premium cars ideal for executive and employee transportation.',
  },
  {
    question: 'Are Aaryan Travels’ corporate cab services suitable for daily employee commute in Chennai?',
    answer: 'Yes, we provide customized corporate cab solutions for daily employee pickups and drops across Chennai.',
  },
  {
    question: 'Are drivers experienced and trained for corporate travel requirements in Chennai?',
    answer: 'Absolutely. Our drivers are professionally trained, courteous, and familiar with corporate travel standards in Chennai.',
  },
  {
    question: 'Can Aaryan Travels handle bulk or group corporate cab bookings in Chennai?',
    answer: 'Yes, we specialize in managing group transportation and bulk bookings for corporate meetings, events, and conferences.',
  },
  {
    question: 'Do you offer monthly billing or invoice options for corporate cab services in Chennai?',
    answer: 'Yes, flexible billing options including monthly invoicing are available for our corporate clients.',
  },
  {
    question: 'Is corporate cab service available 24x7 in Chennai?',
    answer: 'Yes, Aaryan Travels offers round-the-clock corporate cab services in Chennai to ensure seamless business travel.',
  },
  {
    question: 'What safety measures are in place for corporate cab services in Chennai?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety protocols to ensure passenger safety.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for corporate cab bookings in Chennai?',
    answer: 'Yes, full customization of pickup and drop points is available based on your corporate travel needs.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arjun Iyer',
    feedback: 'Aaryan Travels’ corporate cab service in Chennai is punctual and professional. Perfect for our company’s commute.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Nisha Reddy',
    feedback: 'Reliable and efficient corporate cab services by Aaryan Travels in Chennai. Highly recommended for businesses.',
    rating: 5,
  },
];

















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Trusted Corporate Cab Services in Chennai",
  "image": "https://aaryantravels.com/assets/images/trusted-corporate-cab-chennai.jpg", // update with actual image URL
  "description": "Aaryan Travels offers trusted corporate cab services in Chennai, providing reliable business taxis, corporate chauffeur services, and monthly cab rentals for offices and employees.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8", // example rating
    "ratingCount": "3800", // example rating count
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800", // example price
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/trusted-corporate-cab-services-chennai"
  }
};






  return (
    <div>
<Helmet>
  <title>Trusted Corporate Cab Services in Chennai | Reliable Business Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Experience trusted corporate cab services in Chennai with Aaryan Travels. Reliable business taxis, executive cabs, and monthly employee transport solutions at affordable prices."
  />
  <meta
    name="keywords"
    content="Trusted Corporate Cab Services in Chennai, Reliable Business Taxi Chennai, Corporate Transport Chennai, Office Cab Services Chennai, Corporate Chauffeur Chennai, Employee Cab Chennai, Chennai Corporate Car Hire, Monthly Corporate Cab Chennai, Affordable Corporate Cab Chennai, Executive Cab Chennai, Trusted Corporate Taxi Chennai, Staff Transport Chennai, Premium Corporate Cab Chennai, Corporate Car Rental Chennai, Trusted Business Cab Chennai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/43.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Trustedcorporatecabserviceinchennai;